import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

// function loadScript(url) {
//     let node = document.createElement('script');
//     node.src = url;
//     node.type = 'text/javascript';
//     node.async = true;
//     node.charset = 'utf-8';
//     document.getElementsByTagName('head')[0].appendChild(node);
// }

// const documentServer = environment.apiDomain.documentServer || 'http://14.225.3.52:9201';
// if (documentServer) {
//     try {
//         loadScript(documentServer + '/web-apps/apps/api/documents/api.js');
//     } catch (e) {
//         console.log('cannot add api.js', e);
//     }
// }

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
